export function isPromise(obj: any): obj is Promise<any> {
  // Copy/pasted from https://raw.githubusercontent.com/angular/angular/3f331b53b2d13671c3585a57fd228cc263d4b8d1/packages/core/src/util/lang.ts
  // allow any Promise/A+ compliant thenable.
  // It's up to the caller to ensure that obj.then conforms to the spec
  return obj != null && typeof obj.then === 'function';
}

export function backoffMs(attemptCount: number): number {
  // eslint-disable-next-line no-bitwise
  return (attemptCount ^ 2) * 250;
}
